import { useMemo } from 'react';

import { PermissionId, RoleScope, workspacesConfig } from 'utils/powerLevelsConfig';

const useScopeLockedPermissions = (permissions: Record<PermissionId, boolean>): Record<PermissionId, boolean> =>
  useMemo(() => {
    const highestCheckedByScope: Record<RoleScope, number> = { workspace: 0, chat: 0, meeting: 0 };

    for (const [id, enabled] of Object.entries(permissions) as Array<[PermissionId, boolean]>) {
      if (!enabled) continue;
      const entry = workspacesConfig[id];
      if (!entry) continue;
      if (entry.powerLevel > highestCheckedByScope[entry.scope]) {
        highestCheckedByScope[entry.scope] = entry.powerLevel;
      }
    }

    return Object.values(PermissionId).reduce<Record<PermissionId, boolean>>(
      (acc, id) => {
        const entry = workspacesConfig[id];
        acc[id] = entry.powerLevel < highestCheckedByScope[entry.scope];
        return acc;
      },
      {} as Record<PermissionId, boolean>
    );
  }, [permissions]);

export default useScopeLockedPermissions;
